import React from 'react'; 
import PropTypes from 'prop-types';
import util from '../../../lib/util';
import * as consts from '../../../constants';
//Components
import FortisButton from '../../Basic/FortisButton';

const WorksiteContactInfo = ({ customerType, customer, userAuthenticate, workSiteContact, workSiteContactModel, resetProjectSpecifics, onEditClicked, pageName }) => {
    //No customer provided
    //workSiteContactName,workSiteContactPhone,workSiteContactPhone_ext,workSiteCellPhone
    if (!customer || !customerType) return null;
    let contact = null;
    let edit = () => {
        resetProjectSpecifics();
        let stepNumber = (workSiteContact == "1") ? 1 : (userAuthenticate ? 2 : 3);
        if (workSiteContact !== "1" && pageName == consts.NEW_GAS_LINE_NAME)
            stepNumber++;
        onEditClicked(stepNumber);
    };
    if (workSiteContact == "1")//The account holder is worksite contact
    {
        let customerDetails = "";
        switch (customerType) {
            case "1":
                customerDetails = (
                    <span>
                        {customer.FirstName} {customer.LastName}
                    </span>
                );
                break;
            case "2":
            case "3":
                customerDetails = (
                    <span>{customer.BusinessName}</span>
                );
                break;
        }
        contact =
            (
                <div>
                    {customerDetails}
                    <br />
                    <span>Primary phone: {util.formatPhoneNumber(customer.PrimaryPhone + (customer.PrimaryPhoneExt || ""))}<br /></span>
                    {(customer.PrimaryCellPhone) ?
                        (<span>Primary cell phone: {util.formatPhoneNumber(customer.PrimaryCellPhone)}<br /></span>)
                        : null
                    }

                </div>
            );
    }
    if (workSiteContact == "2")//A different contact is worksite contact
    {
        contact = (
            <div>
                <span>{workSiteContactModel.Name}</span>
                <br />
                <span>Primary phone: {util.formatPhoneNumber(workSiteContactModel.PrimaryPhone + (workSiteContactModel.PrimaryPhoneExt || ""))}<br /></span>
                {(workSiteContactModel.PrimaryCellPhone) ?
                    (<span>Mobile phone: {util.formatPhoneNumber(workSiteContactModel.PrimaryCellPhone)}<br /></span>)
                    : null
                }
            </div>
        );
    }
    return (
        <div className="row">
            <div className="col-sm-7">
                <b>Work site contact:</b>
                <br />
                {contact}
                <FortisButton text="Edit" onClick={edit}  style={{marginTop: "5px"}} />
            </div>
        </div>
    );
};

WorksiteContactInfo.propTypes = {
    customerType: PropTypes.string.isRequired,
    customer: PropTypes.object.isRequired,
    userAuthenticate: PropTypes.bool,
    workSiteContact: PropTypes.number,
    workSiteContactModel: PropTypes.object,
    onEditClicked: PropTypes.func,
    resetProjectSpecifics: PropTypes.func,
    pageName: PropTypes.string
};

export default WorksiteContactInfo;